/**
 * The GraphQL server rejects requests with invalid UUIDs,
 * so validating the URL params where possible helps in
 * reducing bad requests
 *
 * @see https://github.com/ScentreGroup/commerce_service/blob/v1.25.0/src/lib/validation.ts#L21
 */
const UUID_PATTERN =
  '[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}'

// Digital Gift Card Paths
export const DGC_PRODUCT = '/shop/westfield-digital-gift-card'
export const DGC_CART = '/shop/westfield-digital-gift-card/cart'
export const DGC_CART_ITEM = `${DGC_CART}/:itemId(${UUID_PATTERN})`
export const DGC_CONFIRMATION = '/shop/westfield-digital-gift-card/confirmation'
export const DGC_CHECKOUT = '/shop/westfield-digital-gift-card/checkout'

export const dgcPath = (name: string, group?: string): string => {
  let base = '/shop/westfield-digital-gift-card'
  if (group === 'last-minute') {
    base = `${base}/last-minute`
  }

  switch (name) {
    case 'product':
      return base
    case 'cart':
      return `${base}/cart`
    case 'cart-item':
      return `${base}/cart/:itemId(${UUID_PATTERN})`
    case 'checkout':
      return `${base}/checkout`
    case 'confirmation':
      return `${base}/confirmation`
    default:
      return base
  }
}

export function generateProductPath({
  shopId,
  productId,
  productTitle,
}: {
  shopId: string
  productId: string
  productTitle: string
}): string {
  return `/shop/product/${shopId}/${productId}/${productTitle}`
}

export function generateOrderConfirmationPath({
  orderReference,
}: {
  orderReference: string
}): string {
  return `/shop/confirmation/${orderReference}`
}

// Marketplace Routes
export const PRODUCTS = '/shop/products'
export const PRODUCTS_CATEGORY_L1 = '/shop/products/:cat1'
export const PRODUCTS_CATEGORY_L2 = '/shop/products/:cat1/:cat2'
export const PRODUCTS_CATEGORY_L3 = '/shop/products/:cat1/:cat2/:cat3'
export const PRODUCTS_CATEGORY_L4 = '/shop/products/:cat1/:cat2/:cat3/:cat4'
export const PRODUCT = '/shop/product/:shopId/:productId/:productTitle'
export const CART_ITEM_PRODUCT = `/shop/cart/:shopId/:productId/:itemId(${UUID_PATTERN})`
export const CART = '/shop/cart'

export const CHECKOUT_SHIPPING = '/shop/shipping'
export const CHECKOUT_DETAILS = '/shop/details'
export const CHECKOUT_REVIEW = '/shop/review'

export const CHECKOUT_LOGIN = '/shop/login'
export const CHECKOUT_FULFILMENT = '/shop/checkout/fulfilment'
export const CHECKOUT_PAYMENT = '/shop/checkout/payment'
export const ORDER_CONFIRMATION = '/shop/confirmation/:orderReference'

export const BRAND = '/shop/brand'
export const COLLECTION = '/shop/collection'
export const PROMOTION = '/shop/promotion'
